/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />
/// <reference path="../ilodashmixins.d.ts" />

module App.Common.Filters {
	'use strict';

	function filter(input: string, includeSpaces: boolean = false): string {
		return _.htmlWhitespace(input, includeSpaces);
	};

	angular
		.module('app.common.filters')
		.filter('htmlWhitespace', [() => {return filter;}]);
}